import NotFound from 'components/NotFound';
import ScheduleAppointment from 'components/Patient/self_scheduling';
import CardOnFile from 'components/Patient/self_scheduling/steps/CardOnFile';
import Confirmation from 'components/Patient/self_scheduling/steps/Confirmation';
import ContactInformation from 'components/Patient/self_scheduling/steps/ContactInformation';
import DateAndTimeStep from 'components/Patient/self_scheduling/steps/DateAndTimeStep';
import PracticeStep from 'components/Patient/self_scheduling/steps/PracticeStep';
import ServiceStep from 'components/Patient/self_scheduling/steps/ServiceStep';
import Terms from 'components/Terms';
import Unsubscribe from 'components/Unsubscribe/Unsubscribe';

const SELF_SCHEDULING = [
  {
    path: 'book', // TODO: @rasim discuss to rename this to self-scheduling
    element: <ScheduleAppointment />,
    children: [
      {
        path: 'practice',
        element: <PracticeStep />
      },
      {
        path: 'service',
        element: <ServiceStep />
      },
      {
        path: 'date-and-time',
        element: <DateAndTimeStep />
      },
      {
        path: 'contact-info',
        element: <ContactInformation />
      },
      {
        path: 'card-on-file',
        element: <CardOnFile />
      },
      {
        path: 'confirmation',
        element: <Confirmation />
      },
      {
        path: '*',
        element: <NotFound portal="book" />
      }
    ]
  },
  {
    path: 'terms',
    element: <Terms />
  },
  {
    path: 'unsubscribe',
    element: <Unsubscribe />
  }
];
export default SELF_SCHEDULING;
